const locales = {
    en: {
        wordMinLength: "Your password is too short",
        wordMaxLength: "Your password is too long",
        wordInvalidChar: "Your password contains an invalid character",
        wordNotEmail: "Do not use your email as your password",
        wordSimilarToUsername: "Your password cannot contain your username",
        wordTwoCharacterClasses: "Use different character classes",
        wordRepetitions: "Too many repetitions",
        wordSequences: "Your password contains sequences",
        errorList: "Errors:",
        veryWeak: "Very Weak",
        weak: "Weak",
        normal: "Normal",
        medium: "Medium",
        strong: "Strong",
        veryStrong: "Very Strong"
    },
    nl: {
        wordMinLength: "Uw wachtwoord is te kort",
        wordMaxLength: "Uw wachtwoord is te lang",
        wordInvalidChar: "Uw wachtwoord bevat ongeldige tekens",
        wordNotEmail: "Gebruik niet uw e-mailadres als uw wachtwoord",
        wordSimilarToUsername: "Uw wachtwoord mag niet uw gebruikersnaam bevatten",
        wordTwoCharacterClasses: "Gebruik verschillende tekens",
        wordRepetitions: "Te veel herhalingen",
        wordSequences: "Uw wachtwoord gebruikt reeksen",
        errorList: "Fouten:",
        veryWeak: "Erg zwak",
        weak: "Zwak",
        normal: "Normaal",
        medium: "Gemiddeld",
        strong: "Sterk",
        veryStrong: "Erg sterk"
    },
    de: {
        wordMinLength: "Das Passwort ist zu kurz",
        wordMaxLength: "Das Passwort ist zu lang",
        wordInvalidChar: "Das Passwort enthält ein ungültiges Zeichen",
        wordNotEmail: "Das Passwort darf die E-Mail Adresse nicht enthalten",
        wordSimilarToUsername: "Das Passwort darf den Benutzernamen nicht enthalten",
        wordTwoCharacterClasses: "Bitte Buchstaben und Ziffern verwenden",
        wordRepetitions: "Zu viele Wiederholungen",
        wordSequences: "Das Passwort enthält Buchstabensequenzen",
        errorList: "Fehler:",
        veryWeak: "Sehr schwach",
        weak: "Schwach",
        normal: "Normal",
        medium: "Mittel",
        strong: "Stark",
        veryStrong: "Sehr stark"
    },
    fr: {
        wordMinLength: "Votre mot de passe est trop court",
        wordMaxLength: "Votre mot de passe est trop long",
        wordInvalidChar: "Votre mot de passe contient un caractère invalide",
        wordNotEmail: "Ne pas utiliser votre adresse e-mail comme mot de passe",
        wordSimilarToUsername: "Votre mot de passe ne peut pas contenir votre nom d'utilisateur",
        wordTwoCharacterClasses: "Utilisez différents type de caractères",
        wordRepetitions: "Trop de répétitions",
        wordSequences: "Votre mot de passe contient des séquences",
        errorList: "Erreurs:",
        veryWeak: "Très Faible",
        weak: "Faible",
        normal: "Normal",
        medium: "Moyen",
        strong: "Fort",
        veryStrong: "Très Fort"
    },
    es: {
        wordMinLength: "Tu contraseña es demasiado corta",
        wordMaxLength: "Tu contraseña es muy larga",
        wordInvalidChar: "Tu contraseña contiene un carácter no válido",
        wordNotEmail: "No uses tu email como tu contraseña",
        wordSimilarToUsername: "Tu contraseña no puede contener tu nombre de usuario",
        wordTwoCharacterClasses: "Mezcla diferentes clases de caracteres",
        wordRepetitions: "Demasiadas repeticiones",
        wordSequences: "Tu contraseña contiene secuencias",
        errorList: "Errores:",
        veryWeak: "Muy Débil",
        weak: "Débil",
        normal: "Normal",
        medium: "Media",
        strong: "Fuerte",
        veryStrong: "Muy Fuerte"
    },
    it: {
        wordMinLength: "La tua password è troppo corta",
        wordMaxLength: "La tua password è troppo lunga",
        wordInvalidChar: "La tua password contiene un carattere non valido",
        wordNotEmail: "Non usare la tua e-mail come password",
        wordSimilarToUsername: "La tua password non può contenere il tuo nome",
        wordTwoCharacterClasses: "Usa classi di caratteri diversi",
        wordRepetitions: "Troppe ripetizioni",
        wordSequences: "La tua password contiene sequenze",
        errorList: "Errori:",
        veryWeak: "Molto debole",
        weak: "Debole",
        normal: "Normale",
        medium: "Media",
        strong: "Forte",
        veryStrong: "Molto forte"
    },
};

export const setupPwStrengthTranslator = (locale = 'en') => {
    const messages = locales[locale] || locales.en;

    return (key) => {
        'use strict';
        return messages[key] !== key ? messages[key] || '' : '';
    };
};
